import { encodeURLFragment } from "../utils/encodeURLFragment";
import { unescape } from "../utils/unescape";

export const prepareSetData = (setData) => ({
	...setData,
	plasmidSetName: unescape(setData.plasmidSetName),
	plasmidSetDesc: unescape(setData.plasmidSetDesc),
});

const prepareSequence = (sequence) => ({
	...sequence,
	plasmidID: encodeURLFragment(sequence.plasmidID),
});

export const prepareSequences = (sequencesSet) => ({
	...sequencesSet,
	setData:
		sequencesSet.setData != null
			? prepareSetData(sequencesSet.setData) //
			: null,
	sequences: sequencesSet.sequences.map(prepareSequence),
});

export const preparePlasmid = (plasmid) => ({
	...plasmid,
	plasmidID: encodeURLFragment(plasmid.plasmidID),
	setID: encodeURLFragment(plasmid.setID),
});
